import { CheckCircle } from "react-feather";

export default function LaunchCompletedBadge({ className = "" }) {
  return (
    <span className={`launch-success-badge ${className}`}>
      <CheckCircle size={14} strokeWidth={2.5} />
      Launch Successfully Completed
    </span>
  );
}
